module.exports = __webpack_public_path__ + "static/media/manofthematch.61eb5c70.jpg";